import React from 'react'
import Link from 'next/link'

export const CardHistoryReturnOrder = ({ order }) => {
    return (
        <div className={'CardHistoryReturnOrder'}>
            <div className={'header'}>
                <h2>Заказ №{order.orderNumber}</h2>
                <span>Оформлен возврат</span>
            </div>
            <div className={'main'}>
                <div className={'row-item'}>
                    <h3>Дата возврата:</h3>
                    <p>{order.orderDate}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Сумма возврата:</h3>
                    <p>{order.amount.toLocaleString('RU-ru')} ₽</p>
                </div>
                <div className={'orders'}>
                    {order.orders.map((item) => (
                        <div key={item.orderNumber} className={'order-item'}>
                            <img src={item.img} alt="order-image" />
                            <div className={'order-info'}>
                                <div className={'row-item'}>
                                    <h3>Наименование:</h3>
                                    <p>{item.orderName} ₽</p>
                                </div>
                                <div className={'row-item'}>
                                    <h3>Количество:</h3>
                                    <p>{item.count} ₽</p>
                                </div>
                                <div className={'row-item'}>
                                    <h3>Стоимость:</h3>
                                    <p>
                                        {item.price.toLocaleString('RU-ru')} ₽
                                    </p>
                                </div>
                            </div>
                            <div className={'actions'}>
                                <Link href={''}>Оставить отзыв</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
